import React, { createContext, useState, ReactNode, useContext } from 'react'

interface MADoctorDropdownContextProps {
  selectedDoctorId: number | undefined
  setSelectedDoctorId: (id: number | undefined) => void
}

const MADoctorDropdownContext = createContext<MADoctorDropdownContextProps | undefined>(undefined)

export const MADoctorDropdownProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedDoctorId, setSelectedDoctorId] = useState<number | undefined>(undefined)

  return (
    <MADoctorDropdownContext.Provider value={{ selectedDoctorId, setSelectedDoctorId }}>
      {children}
    </MADoctorDropdownContext.Provider>
  )
}

export const useMADoctorDropdown = (): MADoctorDropdownContextProps => {
  const context = useContext(MADoctorDropdownContext)
  if (!context) throw new Error('useMADoctorDropdown must be used within a MADoctorDropdownProvider')
  return context
}

